import { Dayjs } from 'dayjs';

export const isWeekday = (date: Dayjs): boolean => {
  const day = date.day();
  return day === 0 || day === 6;
};
